const Label = ({ label }) => {
    return ( 
        <label className="text-base font-semibold">
            { label }
        </label>
     );
}
 
export default Label;